import { useCallback } from 'react';

import { logger } from '../../datadog/logger';
import {
  GetTelehealthSessionInfoVariables,
  useGetTelehealthSessionInfoCallback,
} from '../../hooks/useGetTelehealthSessionInfo';
import { loadSegment } from '../../segment/segment';
import { UserType } from '../../types';

export function useGracefullyLoadVisitorSegmentCallback() {
  const [getTelehealthSessionInfo] = useGetTelehealthSessionInfoCallback();
  return useCallback(
    async (variables: GetTelehealthSessionInfoVariables) => {
      let clientUserShortId: string | undefined;
      let getTelehealthSessionInfoError: Error | undefined;
      try {
        const result = await getTelehealthSessionInfo({
          variables,
        });
        clientUserShortId = result.data?.telehealthSessionInfo?.appointment?.clientUserShortId;
      } catch (error) {
        getTelehealthSessionInfoError = error as Error;
      } finally {
        if (!clientUserShortId) {
          logger.warn('Loading Segment without a client user short ID', variables, getTelehealthSessionInfoError);
        }
        loadSegment(UserType.CLIENT, clientUserShortId);
      }
    },
    [getTelehealthSessionInfo],
  );
}
